import React from "react";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";

const Career = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  const containerStyle = {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: isMobile ? "3rem 1.5rem" : isTablet ? "4.5rem 2rem" : "6rem 4rem",
  };

  const sectionTitle = {
    fontSize: isMobile ? "26px" : "38px",
    fontWeight: 700,
    color: "#1E1B4B",
    marginBottom: "20px",
    textAlign: "center",
  };

  const paragraphStyle = {
    fontSize: isMobile ? "14px" : "16px",
    lineHeight: "28px",
    color: "#4B5563",
  };

  const cardStyle = {
    padding: "30px",
    borderRadius: "12px",
    backgroundColor: "#ffffff",
    border: "1px solid #E9E6F5",
    transition: "all 0.3s ease",
  };

  return (
    <>
      <section
        style={{
          background: "linear-gradient(135deg, #0F0A1F, #240046)",
          color: "#ffffff",
          padding: isMobile ? "4rem 1.5rem" : isTablet ? "5rem 2rem" : "6rem 4rem",
          textAlign: "center",
        }}
      >
        <h1
          style={{
            fontSize: isMobile ? "30px" : "48px",
            fontWeight: 700,
          }}
        >
          Careers at InnoByte
        </h1>

        <p
          style={{
            maxWidth: "800px",
            margin: "20px auto 0",
            fontSize: isMobile ? "15px" : "18px",
            color: "#DCD6F7",
            lineHeight: "28px",
          }}
        >
          Join a team delivering real-world infrastructure projects across data
          centres, enterprise networks, Wi-Fi, electronics hardware, and field
          integration.
        </p>
      </section>

      <section style={containerStyle}>
        <h2 style={sectionTitle}>Why Join InnoByte?</h2>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: isMobile
              ? "1fr"
              : "repeat(auto-fit, minmax(300px, 1fr))",
            gap: isMobile ? "20px" : "30px",
            marginTop: "40px",
          }}
        >
          {[
            {
              title: "Execution-Focused Work",
              desc: "Contribute to live projects involving data centre environments, enterprise networks, wireless systems, and hardware deployment.",
            },
            {
              title: "Ownership & Impact",
              desc: "Take responsibility across planning, installation, commissioning, and customer support for critical infrastructure projects.",
            },
            {
              title: "Hands-On Learning",
              desc: "Build expertise in networking, structured cabling, surveillance, electronics integration, and enterprise infrastructure delivery.",
            },
          ].map((item, index) => (
            <div
              key={index}
              style={cardStyle}
              onMouseEnter={(e) =>
                (e.currentTarget.style.boxShadow =
                  "0 12px 30px rgba(106, 13, 173, 0.15)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.boxShadow = "none")
              }
            >
              <h3
                style={{
                  fontWeight: 600,
                  marginBottom: "12px",
                  color: "#6A0DAD",
                }}
              >
                {item.title}
              </h3>
              <p style={{ ...paragraphStyle, margin: 0 }}>{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section style={{ ...containerStyle, paddingTop: 0 }}>
        <h2 style={sectionTitle}>Current Openings</h2>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: isMobile
              ? "1fr"
              : isTablet
              ? "repeat(2, 1fr)"
              : "repeat(auto-fit, minmax(350px, 1fr))",
            gap: isMobile ? "20px" : "30px",
            marginTop: "40px",
          }}
        >
          {[
            {
              title: "Network & Wi-Fi Engineer",
              desc: "Enterprise switching, routing, wireless deployment, controller configuration, surveys, and troubleshooting.",
            },
            {
              title: "Data Centre Deployment Engineer",
              desc: "Rack setup, structured cabling, hardware installation, power coordination, documentation, and commissioning support.",
            },
            {
              title: "ELV / Security Systems Engineer",
              desc: "CCTV, access control, field device integration, testing, and deployment support for commercial environments.",
            },
            {
              title: "Project Coordinator",
              desc: "Vendor coordination, site planning, documentation tracking, scheduling, and customer communication for integration projects.",
            },
          ].map((role, index) => (
            <div
              key={index}
              style={cardStyle}
              onMouseEnter={(e) =>
                (e.currentTarget.style.boxShadow =
                  "0 12px 30px rgba(106, 13, 173, 0.15)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.boxShadow = "none")
              }
            >
              <h4
                style={{
                  fontWeight: 600,
                  marginBottom: "12px",
                  color: "#1E1B4B",
                }}
              >
                {role.title}
              </h4>
              <p style={{ ...paragraphStyle, margin: 0 }}>{role.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section
        style={{
          padding: isMobile ? "3rem 1.5rem" : "5rem 4rem",
          backgroundColor: "#F5F3FF",
          textAlign: "center",
        }}
      >
        <h3
          style={{
            fontWeight: 700,
            marginBottom: "20px",
            color: "#1E1B4B",
          }}
        >
          Ready to Work on Meaningful Infrastructure Projects?
        </h3>

        <a
          href="mailto:careers@innobyte.tech"
          style={{
            background: "linear-gradient(90deg, #6A0DAD, #9D4EDD)",
            padding: isMobile ? "12px 22px" : "12px 30px",
            borderRadius: "8px",
            color: "#ffffff",
            textDecoration: "none",
            fontWeight: 600,
            boxShadow: "0 8px 20px rgba(157, 78, 221, 0.3)",
            display: "inline-block",
            width: isMobile ? "100%" : "auto",
            maxWidth: isMobile ? "280px" : "none",
          }}
        >
          Apply Now
        </a>
      </section>
    </>
  );
};

export default Career;
